import {
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_SUCCESS_STORIES } from './constants';

function formatItems(item) {
  let { profitRate, rateDate, ...props } = item;

  if (!!profitRate) {
    profitRate = profitRate.toString().split('.').join(',');
  }

  if (!!rateDate) {
    rateDate = rateDate.toString().split('-').reverse().join('.');
  }

  return { profitRate, rateDate, ...props };
}

const initialState = {
  results: [],
  isFetching: false,
  fetchingErrors: null
};


export default createReducer(initialState, {
  [GET_SUCCESS_STORIES]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        return Object.assign(state, {
          results: action.request.response.results.map(formatItems),
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/SuccessStories/reducer.js